module.exports = __webpack_public_path__ + "img/Porto Apartment - 8 of 85.1443c74f.jpeg";